export default __webpack_public_path__ + "static/media/sticker-X.ad7b4afd.png";